import React, {Component} from 'react'
import { connect } from 'react-redux'
import BuilderAddons from './builder-helper/BuilderAddons'
import BuilderAddonsList from './builder-helper/BuilderAddonsList'

import deepCopy from 'deepcopy'

let currentTime = (new Date).getTime();

let initialMinibuilder = [];



class Builder extends Component {

  constructor(props){
    super(props);

    this.state = {
      builderData : initialMinibuilder
    }
  }

  componentDidMount ( ){
      const { input: { value, onChange, name } } = this.props

      if (value !='') {
          if (typeof value[0].id == 'undefined') {
            let oldValueBalance = {
              id : currentTime++,
              name : 'text_block',
              settings : {
                text: value
              }
            };

            var newBuilderData = deepCopy( initialMinibuilder )

            newBuilderData.push(oldValueBalance);

            this.setState({ builderData : newBuilderData })
          } else {
            this.setState({ builderData : value })
          }
      }
  }

  componentWillReceiveProps( nextProps ){
    this.setState({ builderData: nextProps.input.value })
  }

  componentDidUpdate(){
    const { input:{ onChange } } = this.props
    onChange( this.state.builderData )
  }

  render(){
    const { input, params } = this.props
    return(
      <div className="sp-pagebuilder-form-group" >
        <label>{ params.title }</label>
        <div className="inside-sp-page-builder-wrap">
        <BuilderAddons inputName = { input.name } builderAddons = { this.state.builderData }/>
        <BuilderAddonsList  inputName = { input.name } />
        </div>
      </div>
    )
  }
}


export default connect()(Builder);



// WEBPACK FOOTER //
// ./src/helpers/form/types/Builder.js